import styled, { css } from 'styled-components';
import { FieldRowProps } from './types';

export const FieldRow = styled.div<FieldRowProps>`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.km10};

  & > *:not(:first-child) {
    margin-left: ${({ theme }) => theme.spacing.km6};
  }

  ${({ $isLastRow }) =>
    $isLastRow &&
    css`
      margin-bottom: ${({ theme }) => theme.spacing.km10};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column;
    margin-bottom: ${({ theme }) => theme.spacing.km0};

    & > *:not(:first-child) {
      margin-left: ${({ theme }) => theme.spacing.km0};
    }

    & > * {
      margin-bottom: ${({ theme }) => theme.spacing.km10};
    }
  }
`;
